import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
`;

export const Title = styled.h1`
  margin: 0;
`;

export const SubTitle = styled.span`
  font-weight: 600;
  margin: 1rem 0 0.5rem;
`;

export const Image = styled.img``;
